import { useCallback } from 'react';
import { useAppDispatch, useAppSelector } from '../hooks';
import {
  fetchBusinessUnit,
  fetchBusinessUnitsWithDivisionsApiThunk,
  deleteBusinessUnitApiThunk,
  updateBusinessUnitApiThunk,
  addToBUwithDivisions,
  createBusinessUnitApiThunk,
  clearBusinessUnitMessages,
} from './businessUnitSlice';
import { RootState } from '..';
import {
  BusinessUnit,
  BusinessUnitWithDivisions,
  CreateBusinessUnitRequest,
  DeleteBusinessUnitRequest,
  ListBusinessUnitRequest,
  UpdateBusinessUnitRequest,
} from 'src/types/orbit/BusinessUnit';

export const useBusinessUnit = () => {
  const dispatch = useAppDispatch();
  const businessUnitList = useAppSelector(
    (state: RootState) => state.businessUnits.businessUnitList,
  );
  const fetchBusinessUnitApiStatus = useAppSelector(
    (state: RootState) => state.businessUnits.fetchBusinessUnitApiStatus,
  );
  const fetchBusinessUnitsWithDivisionsApiStatus = useAppSelector(
    (state: RootState) => state.businessUnits.fetchBusinessUnitsWithDivisionsApiStatus,
  );

  const businessUnitsWithDivisions = useAppSelector(
    (state: RootState) => state.businessUnits.businessUnitsWithDivisions,
  );

  const deleteBusinessUnitApiStatus = useAppSelector(
    (state: RootState) => state.businessUnits.deleteBusinessUnitApiStatus,
  );
  const updateBusinessUnitApiStatus = useAppSelector(
    (state: RootState) => state.businessUnits.updateBusinessUnitApiStatus,
  );

  const createBusinessUnitApiStatus = useAppSelector(
    (state: RootState) => state.businessUnits.createBusinessUnitApiStatus,
  );
  const loadBusinessUnits = useCallback(
    (data: ListBusinessUnitRequest) => {
      dispatch(fetchBusinessUnit(data));
    },
    [dispatch],
  );

  const loadBusinessUnitsWithDivisions = useCallback(
    (data: ListBusinessUnitRequest) => {
      dispatch(fetchBusinessUnitsWithDivisionsApiThunk(data));
    },
    [dispatch],
  );

  const deleteBusinessUnit = useCallback(
    (deleteData: DeleteBusinessUnitRequest) => {
      dispatch(deleteBusinessUnitApiThunk(deleteData));
    },
    [dispatch],
  );

  const updateBusinessUnit = useCallback(
    (updateData: UpdateBusinessUnitRequest) => {
      dispatch(updateBusinessUnitApiThunk(updateData));
    },
    [dispatch],
  );

  const createNewBusinessUnit = useCallback(
    (data: CreateBusinessUnitRequest) => {
      dispatch(createBusinessUnitApiThunk(data));
    },
    [dispatch],
  );

  const addNewBusinessUnitToBUwithDivisions = useCallback(
    (businessUnit: BusinessUnitWithDivisions) => {
      dispatch(addToBUwithDivisions(businessUnit));
    },
    [dispatch],
  );
  const clearAllBusinessUnitApiMessages = useCallback(() => {
    dispatch(clearBusinessUnitMessages());
  }, [dispatch]);

  return {
    businessUnitList,
    businessUnitsWithDivisions,
    fetchBusinessUnitApiStatus,
    fetchBusinessUnitsWithDivisionsApiStatus,
    updateBusinessUnitApiStatus,
    deleteBusinessUnitApiStatus,
    createBusinessUnitApiStatus,
    loadBusinessUnits,
    createNewBusinessUnit,
    loadBusinessUnitsWithDivisions,
    deleteBusinessUnit,
    updateBusinessUnit,
    addNewBusinessUnitToBUwithDivisions,
    clearAllBusinessUnitApiMessages,
  };
};
